import React, { useCallback, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import { TERM, INDICATOR_CHART_TERM } from "../logic/chartConfig"
import { changeTerm } from "redux/ducks/Chart"
import { indicatorChartChangeType } from "redux/ducks/IndicatorChart"
import ChartBaseSelector from "./ChartBaseSelector"
import { includes, get, filter, pick, find } from "lodash"
import { SECURITY_TYPE, EQUITY_SECURITY_LIST, EXCHANGE } from "config/const"

interface props {
  canvasId: string
}

// 米株・商品（金現物、銀現物以外）
const LIMIT_LEG_ARRAY = [
  EQUITY_SECURITY_LIST[1].SecurityType,
  SECURITY_TYPE.GCc1.id,
  SECURITY_TYPE.SIc1.id,
  SECURITY_TYPE.PLc1.id,
  SECURITY_TYPE.PAc1.id,
  SECURITY_TYPE.CLc1.id,
  SECURITY_TYPE.XAUFIX.id,
]

// 米国指数・イスラエル指数
const LIMIT_LEG_OBJECT = [
  { SecurityType: SECURITY_TYPE.Index.id, Exchange: EXCHANGE.NYSE.id },
  { SecurityType: SECURITY_TYPE.Index.id, Exchange: EXCHANGE.ILSE.id },
]

const ChartLegFilter = React.memo((props: props) => {
  const { canvasId } = props
  const dispatch = useDispatch()
  const termSelector = (state: any) => state.chart[canvasId].term
  const symbolSelector = (state: any) => state.chart[canvasId].symbol
  const term = useSelector(termSelector)
  const symbol = useSelector(symbolSelector)

  const setTerm = useCallback((id: number) => {
    dispatch(changeTerm(canvasId, id))
  }, [])

  const termList = useMemo(() => {
    if (
      includes(LIMIT_LEG_ARRAY, get(symbol, "SecurityType")) ||
      !!find(LIMIT_LEG_OBJECT, pick(symbol, ["SecurityType", "Exchange"]))
    ) {
      dispatch(changeTerm(canvasId, 8))
      return filter(TERM, (_, id) => !includes([0, 1, 2, 3, 4, 5, 6, 7], id))
    }
    return TERM
  }, [symbol])

  return (
    <div className="chart-leg-filter">
      <ChartBaseSelector
        list={termList}
        onChange={setTerm}
        defaltValueId={term.id}
      />
    </div>
  )
})

export const IndicatorChartLegFilter = (props: props) => {
  const { canvasId } = props
  const dispatch = useDispatch()
  const typeSelector = (state: any) => state.indicatorChart[canvasId].type
  const type = useSelector(typeSelector)
  const setIndicatorChartType = (id: number) =>
    dispatch(indicatorChartChangeType(canvasId, id))

  return (
    <ChartBaseSelector
      list={INDICATOR_CHART_TERM}
      onChange={setIndicatorChartType}
      defaltValueId={type}
    />
  )
}

export const MiniChartListLegFilter = (props: {
  onChange: Function
  defaltValueId: number
}) => {
  const { onChange, defaltValueId } = props
  return (
    <ChartBaseSelector
      list={TERM}
      onChange={onChange}
      defaltValueId={defaltValueId}
    />
  )
}

export default ChartLegFilter
